import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, map, Observable, of, Subject } from 'rxjs';
import { LanguageService } from './language.service';
import { SessionService } from './session.service';
import { BackendService } from './backend.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  ///// when user have default value
  fillingData = true;
  fillingStatus = 'loading';

  errorMessage = '';
  AppId?: string;
  ParentId?: string;
  /////////////merchant  ///////////
  ///////////////// 1 select merchant
  merchants: any[] = [];
  _selectedMerchant: any = JSON.parse(sessionStorage.getItem('selectedMerchant') || 'null');
  Category = 'all';
  _merchantCategories: any;
  merchantCategoryId: number = 0;
  merchantSkipRecord: number = 0;
  merchantTakeRecord: number = 20;
  loadingMerchants: number = 0;

  ///////////////// 2 get the nearest merchant branch
  merchantBranches: any;
  _selectedMerchantBranch: any = JSON.parse(sessionStorage.getItem('selectedMerchantBranch') || 'null');

  /////////////Application  ///////////
  ProductID!: string;
  ///////////////// 1 get  branch city & branch & promotionCode
  BranchCities!: any[];

  allCities!: any[];
  selectedBranchRegion: any;
  selectedBranchCity: any;
  tasheelBranches: any;
  selectedTasheelBranch: any;
  promotionCode!: FormControl;
  ///////////////// 2 Date of birth
  IsDobGregorian = !this.session.isSaudi;
  IsIdExpiryGregorian = !this.session.isSaudi;
  _dateOfBirth!: FormControl;
  ///////////////// 3 get the users company
  companies: any;
  selectedCompany: any;
  ///////////////// 4,6 get the job title
  jobTitles: any;
  selectedJobTitle: any;
  ///////////////// 5 if the company is unlisted
  _employerName!: FormControl;
  _CR!: FormControl;
  _companyBuildingName!: FormControl;
  _companyStreetName!: FormControl;
  selectedCompanyCity: any;
  ///////////////// 7  length of employment
  serviceDurations: any;
  _selectedTimeOfEmployment!: FormControl;
  ///////////////// 8 monthly income
  _monthlyIncome!: FormControl;

  ///////////////// 9 purpose of loan
  PurposesOfLoan: any;
  selectedPurposeOfLoan: any;
  ///////////////// 10 politically exposed
  readMore = false;
  isPoliticallyExposed!: FormControl;
  ///////////////// 11 terms
  IAgree!: FormControl;
  IsFinalBeneficiary = false;
  IsTesheelAccess = false;
  ///////////////// 12 extra expenses
  showExpensesForm = false;
  _foodExpenses!: FormControl;
  _maidDriverExpenses!: FormControl;
  _healthcareExpenses!: FormControl;
  _transporationCommunicationExpense!: FormControl;
  _insuranceExpense!: FormControl;
  _educationExpenses!: FormControl;
  _housingRent!: FormControl;
  _otherExpenses!: FormControl;
  _otherPrivateLoans!: FormControl;

  ///////////////// 13 address
  _unitAddressNumber!: FormControl;
  _streetAddressName!: FormControl;
  selectedAdressCity: any;
  ///////////////// 14 residense type
  residenceTypes: any;
  _selectedResidenceType!: FormControl;
  ///////////////// 15 email
  email!: FormControl;

  ///////////////// 16  employer type
  employerTypes: any;
  _selectedEmployerType!: FormControl;
  /////////////////
  loading = false;
  military = false;
  unlisted = false;
  ApplicationForm!: FormGroup;
  ////////////// behaviuor objects//////////////////////
  private categoriesSubject = new BehaviorSubject<Array<any>>([]);

  categories$ = this.categoriesSubject.asObservable();
  constructor(
    private session: SessionService,
    private languageService: LanguageService,
    private backend: BackendService
  ) {
    this.initFormControl();
  }

  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }

  /**
   * field getter and setters
   */

  get dateOfBirth() {
    return this._dateOfBirth.value;
  }

  set dateOfBirth(val) {
    this._dateOfBirth.setValue(val);
  }

  get selectedResidenceType() {
    return this._selectedResidenceType.value;
  }

  set selectedResidenceType(val) {
    this._selectedResidenceType.setValue(val);
  }
  get selectedEmployerType() {
    return this._selectedEmployerType.value;
  }

  set selectedEmployerType(val) {
    this._selectedEmployerType.setValue(val);
  }

  get employerName() {
    return this._employerName.value;
  }

  set employerName(val) {
    if (!val) {
      this._employerName.setValue('');
      return;
    }
    let characterError;
    if (this.isLeft)
      characterError = /[^\x41-\x5A^\x61-\x7A^\x30-\x39 ]/.test(val);
    else
      characterError = /[^\u060C-\u06D2^\x30-\x39 ]/.test(val);

    val = val.slice(0, 50);
    this._employerName.setValue(val);
    
    if (characterError)
      this._employerName.setErrors({ invalidChar: true });
    else
    {
      this._employerName.setErrors({ invalidChar: null });
      this._employerName.updateValueAndValidity();
    }
  }

  get CR() {
    return this._CR.value;
  }

  set CR(val) {
    if (!val) {
      this._CR.setValue('');
      return;
    }

    let characterError;
    characterError = /[^\x30-\x39 ]/.test(val);

    val = val.slice(0, 10);
    this._CR.setValue(val);

    if (characterError)
      this._CR.setErrors({ invalidChar: true });
    else
    {
      this._CR.setErrors({ invalidChar: null });
      this._CR.updateValueAndValidity();
    }
  }

  get companyBuildingName() {
    return this._companyBuildingName.value;
  }

  set companyBuildingName(val) {
    if (!val) {
      this._companyBuildingName.setValue('');
      return;
    }

    let characterError;
    if (this.isLeft)
      characterError = /[^\x41-\x5A^\x61-\x7A^\x30-\x39 ]/.test(val);
    else
      characterError = /[^\u060C-\u06D2^\x30-\x39 ]/.test(val);

    val = val.slice(0, 50);
    this._companyBuildingName.setValue(val);

    if (characterError)
      this._companyBuildingName.setErrors({ invalidChar: true });
    else
    {
      this._companyBuildingName.setErrors({ invalidChar: null });
      this._companyBuildingName.updateValueAndValidity();
    }
  }

  get companyStreetName() {
    return this._companyStreetName.value;
  }

  set companyStreetName(val) {
    if (!val) {
      this._companyStreetName.setValue('');
      return;
    }

    let characterError;
    if (this.isLeft)
      characterError = /[^\x41-\x5A^\x61-\x7A^\x30-\x39 ]/.test(val);
    else
      characterError = /[^\u060C-\u06D2^\x30-\x39 ]/.test(val);

    val = val.slice(0, 50);
    this._companyStreetName.setValue(val);
    if (characterError)
      this._companyStreetName.setErrors({ invalidChar: true });
    else
    {
      this._companyStreetName.setErrors({ invalidChar: null });
      this._companyStreetName.updateValueAndValidity();
    }
  }

  get selectedTimeOfEmployment() {
    return this._selectedTimeOfEmployment.value;
  }

  set selectedTimeOfEmployment(val) {
    this._selectedTimeOfEmployment.setValue(val);
  }

  get unitAddressNumber() {
    return this._unitAddressNumber.value;
  }
  set unitAddressNumber(val) {
    if (!val) {
      this._unitAddressNumber.setValue('');
      return;
    }
    let characterError;
    if (this.isLeft)
      characterError = /[^\x41-\x5A^\x61-\x7A^\x30-\x39 ]/.test(val);
    else
      characterError = /[^\u060C-\u06D2^\x30-\x39 ]/.test(val);

    val = val.slice(0, 50);
    this._unitAddressNumber.setValue(val);
    if (characterError)
      this._unitAddressNumber.setErrors({ invalidChar: true });
    else
    {
      this._unitAddressNumber.setErrors({ invalidChar: null });
      this._unitAddressNumber.updateValueAndValidity();
    }
  }

  get streetAddressName() {
    return this._streetAddressName.value;
  }

  set streetAddressName(val) {
    if (!val) {
      this._streetAddressName.setValue('');
      return;
    }
    let characterError;
    if (this.isLeft)
      characterError = /[^\x41-\x5A^\x61-\x7A^\x30-\x39 ]/.test(val);
    else
      characterError = /[^\u060C-\u06D2^\x30-\x39 ]/.test(val);

    val = val.slice(0, 50);
    this._streetAddressName.setValue(val);
    if (characterError) {
      this._streetAddressName.setErrors({ invalidChar: true });
    } else {
      this._streetAddressName.setErrors({ invalidChar: null });
      this._streetAddressName.updateValueAndValidity();
    }
  }

  get monthlyIncome() {
    return this._monthlyIncome.value;
  }

  set monthlyIncome(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);

    this._monthlyIncome.setValue(val || '');
    let el: any = document.getElementById('incomeInput');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get foodExpenses() {
    return this._foodExpenses.value;
  }

  set foodExpenses(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._foodExpenses.setValue(val || '');

    let el: any = document.getElementById('FoodExpenses');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get maidDriverExpenses() {
    return this._maidDriverExpenses.value;
  }

  set maidDriverExpenses(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._maidDriverExpenses.setValue(val || '');

    let el: any = document.getElementById('maidDriverExpenses');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get educationExpenses() {
    return this._educationExpenses.value;
  }

  set educationExpenses(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._educationExpenses.setValue(val || '');

    let el: any = document.getElementById('educationExpenses');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get transporationCommunicationExpense() {
    return this._transporationCommunicationExpense.value;
  }

  set transporationCommunicationExpense(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._transporationCommunicationExpense.setValue(val || '');

    let el: any = document.getElementById('transporationCommunicationExpense');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get healthcareExpenses() {
    return this._healthcareExpenses.value;
  }

  set healthcareExpenses(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._healthcareExpenses.setValue(val || '');

    let el: any = document.getElementById('healthcareExpenses');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get otherPrivateLoans() {
    return this._otherPrivateLoans.value;
  }

  set otherPrivateLoans(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._otherPrivateLoans.setValue(val || '');

    let el: any = document.getElementById('otherPrivateLoans');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get insuranceExpense() {
    return this._insuranceExpense.value;
  }

  set insuranceExpense(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._insuranceExpense.setValue(val || '');

    let el: any = document.getElementById('insuranceExpense');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get housingRent() {
    return this._housingRent.value;
  }

  set housingRent(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._housingRent.setValue(val || '');

    let el: any = document.getElementById('housingRent');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  get otherExpenses() {
    return this._otherExpenses.value;
  }

  set otherExpenses(val: string) {
    val = val = val.replace(/\D/g, '').slice(0, 6);
    this._otherExpenses.setValue(val || '');

    let el: any = document.getElementById('otherExpenses');
    setTimeout(() => {
      el.value = this.addComma(val || '');
    }, 0);
  }

  addComma(val: string) {
    if (!val) return '';
    val = [...val].reverse().join('');
    let fragments = val.match(/(.{1,3})/g)?.map((el) => [...el].reverse().join(''));
    fragments?.reverse();
    return fragments?.join(',');
  }

  //retrieves the application information from the server
  getApplicationInformation(appId: string): Observable<any> {
    var appSubject = new Subject<any>();
    //this.backend.checkAppForeignAccess(appId).subscribe();
    this.backend.GetApplication(appId).subscribe({
      next: (res: any) => {
        let app: any = {};
        //Product Details
        app.AppId = appId;
        app.ProductID = res.Data.ProductID;
        app.Tenure = res.Data.Tenure;
        app.Amount = res.Data.Amount;
        app.MerchantStoreId = res.Data.MerchantStoreId;
        app.MobileNumber = res.Data?.MobileNumber;
        if (res.Data.PurposeOfLoan)
          app.PurposeOfLoan = res.Data.PurposeOfLoan;
        //Address
        if (res.Data.Street)
          app.Street = res.Data.Street;
        if (res.Data.BuildingNumber)
          app.BuildingNumber = res.Data.BuildingNumber;
        //Expenses
        if (res.Data.DeclaredTotalEMI)
          app.DeclaredTotalEMI = res.Data.DeclaredTotalEMI;
        if (res.Data.DeclaredTotalCreditCardLimit)
          app.DeclaredTotalCreditCardLimit = res.Data.DeclaredTotalCreditCardLimit;
        if (res.Data.HasMortage)
          app.HasMortage = res.Data.HasMortage;
        //Employment
        if (res.Data.EmploymentType)
          app.EmploymentTypeId = res.Data.EmploymentType;
        if (res.Data.EmploymentTypeId)
          app.EmploymentTypeId = res.Data.EmploymentTypeId;
        app.EmployerCode = res.Data.EmployerCode; //duplicated
        app.CompanyCode = res.Data.EmployerCode; //duplicated
        app.Income = res.Data.Income;
        app.JobTitleCode = res.Data.JobTitleCode;
        if (res.Data.ServiceDurationCode)
          app.ServiceDurationCode = res.Data.ServiceDurationCode;
        //Employer Address
        app.EmployerBuildingNumber = res.Data.EmployerBuildingNumber;
        app.EmployerStreet = res.Data.EmployerStreet;
        //Personal Information
        app.firstname_En = res.Data.Firstname_En;
        app.middlename_En = res.Data.Middlename_En;
        app.lastname_En = res.Data.Lastname_En;
        app.firstname_Ar = res.Data.Firstname_Ar;
        app.middlename_Ar = res.Data.Middlename_Ar;
        app.lastnameAr = res.Data.LastnameAr;
        if (res.Data.DateOfBirth)
          app.DateOfBirth = res.Data.DateOfBirth;
        app.IsDobGregorian = res.Data.IsGregorian;  //Potentially wrong. Needs to be checked. This always returns true from the backend
        app.IsIdExpiryGregorian = res.Data.IsGregorian; //Potentially wrong. Needs to be checked. This always returns true from the backend
        app.IsPoliticallyExposed = res.Data.IsPoliticallyExposed;
        //Email
        if (res.Data.Email)
          app.Email = res.Data.Email;
        //Marketing
        if (res.Data.IsMarketDeclared)
          app.IsMarketDeclared = res.Data.IsMarketDeclared;
        app.JourneyTrackingId = res.Data?.JourneyTrackingId;
        appSubject.next(app);
      }
    });
    return appSubject.asObservable();
  }

  reload() {
    /////////////merchant  ///////////
    ///////////////// 1 select merchant
    this.merchants = [];
    sessionStorage.removeItem('selectedMerchant');
    this._merchantCategories = undefined;
    this.merchantCategoryId = 0;
    this.merchantSkipRecord = 0;
    this.merchantTakeRecord = 20;
    this.loadingMerchants = 0;
    ///////////////// 2 get the nearest merchant branch
    this.merchantBranches = undefined;
    sessionStorage.removeItem('selectedMerchantBranch');
    ///////////////// 1 get  branch city & branch & promotionCode
    this.selectedBranchRegion = null;
    this.selectedTasheelBranch = null;
    this.tasheelBranches = undefined;
    ///////////////// 2 Date of birth
    this.IsDobGregorian = !this.session.isSaudi;
    this.IsIdExpiryGregorian = !this.session.isSaudi;
    ///////////////// 3 get the users company
    this.companies = undefined;
    this.selectedCompany = null;
    ///////////////// 4,6 get the job title
    this.jobTitles = undefined;
    this.selectedJobTitle = null;
    ///////////////// 5 if the company is unlisted
    this.selectedCompanyCity = null;
    ///////////////// 7  length of employment
    this.serviceDurations = undefined;
    ///////////////// 9 purpose of loan
    this.PurposesOfLoan = undefined;
    this.selectedPurposeOfLoan = null;
    ///////////////// 10 politically exposed
    this.readMore = false;

    ///////////////// 12 extra expenses
    this.showExpensesForm = false;
    ///////////////// 13 address
    this.selectedAdressCity = null;
    ///////////////// 14 residense type
    this.residenceTypes = undefined;
    /////////////////  employer type
    this.employerTypes = undefined;
    ///////////////// 15 email

    /////////////////
    this.loading = false;
    this.military = false;
    this.unlisted = false;

    this.initFormControl();
  }

  private initFormControl() {
    this.promotionCode = new FormControl(undefined, [Validators.pattern('^[A-Za-z]{4}[\\d]{6}$')]);
    //////////////// 2 Date of birth
    this._dateOfBirth = new FormControl<Date | undefined>(undefined, [Validators.required]);
    //////////////// 4,6 get the job title

    //////////////// 5 if the company is unlisted
    this._employerName = new FormControl(undefined, [Validators.required]);
    this._CR = new FormControl(undefined, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]);
    this._companyBuildingName = new FormControl(undefined, [Validators.required]);
    this._companyStreetName = new FormControl(undefined, [Validators.required]);

    //////////////// 7  length of employment
    this._selectedTimeOfEmployment = new FormControl(undefined, [Validators.required]);
    //////////////// 8 monthly income
    this._monthlyIncome = new FormControl(undefined, [Validators.required]);
    //////////////// 9 purpose of loan

    //////////////// 10 politically exposed
    this.isPoliticallyExposed = new FormControl(false, [Validators.required]);
    //////////////// 11 Terms
    this.IAgree = new FormControl(false, [Validators.requiredTrue]);
    //////////////// 12 extra expenses
    this._foodExpenses = new FormControl(0);
    this._maidDriverExpenses = new FormControl(0);
    this._healthcareExpenses = new FormControl(0);
    this._transporationCommunicationExpense = new FormControl(0);
    this._insuranceExpense = new FormControl(0);
    this._educationExpenses = new FormControl(0);
    this._housingRent = new FormControl(0);
    this._otherExpenses = new FormControl(0);
    this._otherPrivateLoans = new FormControl(0);
    //////////////// 13 address
    this._unitAddressNumber = new FormControl(undefined, [Validators.required]);
    this._streetAddressName = new FormControl(undefined, [Validators.required]);

    //////////////// 14 residense type

    this._selectedResidenceType = new FormControl(undefined, [Validators.required]);
    //////////////// 15 email
    this.email = new FormControl(undefined, [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]);
    //////////////// 16 employer type

    this._selectedEmployerType = new FormControl(undefined, [Validators.required]);
    this.initFormGroup();
  }

  initFormGroup() {
    this.ApplicationForm = new FormGroup({
      ///////////////// 1 get  branch city & branch & promotionCode

      promotionCode: this.promotionCode,
      //////////////// 2 Date of birth
      dateOfBirth: this._dateOfBirth,
      //////////////// 4,6 get the job title

      //////////////// 5 if the company is unlisted
      employerName: this._employerName,
      CR: this._CR,
      companyBuildingName: this._companyBuildingName,
      companyStreetName: this._companyStreetName,

      //////////////// 7  length of employment
      selectedTimeOfEmployment: this._selectedTimeOfEmployment,
      //////////////// 8 monthly income
      monthlyIncome: this._monthlyIncome,
      //////////////// 9 purpose of loan

      //////////////// 10 politically exposed
      isPoliticallyExposed: this.isPoliticallyExposed,
      //////////////// 11 IAgree
      IAgree: this.IAgree,

      //////////////// 12 extra expenses
      foodExpenses: this._foodExpenses,
      maidDriverExpenses: this._maidDriverExpenses,
      healthcareExpenses: this._healthcareExpenses,
      transporationCommunicationExpense: this._transporationCommunicationExpense,
      insuranceExpense: this._insuranceExpense,
      educationExpenses: this._educationExpenses,
      housingRent: this._housingRent,
      otherExpenses: this._otherExpenses,
      otherPrivateLoans: this._otherPrivateLoans,
      //////////////// 13 address
      unitAddressNumber: this._unitAddressNumber,
      streetAddressName: this._streetAddressName,

      //////////////// 14 residense type

      selectedResidenceType: this._selectedResidenceType,
      //////////////// 15 email
      email: this.email,
      //////////////// 16 employer type

      selectedemployerType: this._selectedEmployerType,
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class Application {
  AppId?: string;
  JourneyTrackingId! : string | null;
  RegionID?: number;
  EmploymentTypeId?: number;
  EmployerType?: number;
  CompanyCode?: string;
  EmployerCode?: string;
  JobTitleCode?: number;
  ServiceDurationCode?: number;
  Income?: number = 0;
  Email?: string;
  ProductID?: number;
  DateOfBirth?: string;
  IsDobGregorian?: boolean;
  IsIdExpiryGregorian?: boolean;
  IsPoliticallyExposed?: boolean;
  FoodExpenses?: number = 0;
  HousingRent?: number = 0;
  MaidDriverExpense?: number = 0;
  EducationExpenses?: number = 0;
  TransporationCommunicationExpense?: number = 0;
  HealthcareExpenses?: number = 0;
  InsuranceExpense?: number = 0;
  OtherExpenses?: number = 0;
  NumberOfDependents?: number = 0;
  OtherPrivateLoans?: number = 0;
  DeclaredTotalEMI?: number = 0;
  DeclaredTotalCreditCardLimit?: number = 0;
  ReferralCode?: string;
  EmployerName?: string;
  EmployerCR?: string;
  EmployerBuildingNumber?: string;
  EmployerStreet?: string;
  EmployerCityCode?: string;
  EmployerRegionCode?: number;
  StoreID?: number;
  MerchantId?: number;
  MerchantStoreId?: number;
  MaritalStatus?: number;
  HasMortage?: boolean;
  OtherCards?: number = 0;
  IdExpiryDate?: string;
  firstname_En?: string;
  middlename_En?: string;
  lastname_En?: string;
  firstname_Ar?: string;
  middlename_Ar?: string;
  lastnameAr?: string;
  PurposeOfLoan?: string;
  Street?: string;
  IsMarketDeclared?: boolean = false;
  Amount? : number;
  utmId? : number;
  PId? : number;
  MobileNumber? : string;
  ReferralId?: string;
}

export class Customer {
  CivilId?: number;
  ClientId?: string;
  UserID?: string;
}

export class PayDues {
  Amount?: number;
  ContractNumber?: string;
  Cvv?: number;
  CardId?: string;
}

